import { StrapiResponsiveImageData } from '../image';
import { ResponsiveVideoData } from '../video/types';

export const textBlockComponentName = 'shared.textblock';

export type TextBlockData = {
  strapi_component: typeof textBlockComponentName;
} & {
  Content: {
    data: {
      childMarkdownRemark: {
        html: string;
      };
    };
  };
};

export const introTextComponentName = 'shared.intro-text';

export type IntroTextData = {
  strapi_component: typeof introTextComponentName;
} & {
  text: {
    data: {
      childMarkdownRemark: {
        html: string;
      };
    };
  };
  showCTA: boolean;
};

export const buttonComponentName = 'shared.button';

export type ButtonData = {
  strapi_component: typeof buttonComponentName;
} & {
  title: string;
  linkUrl: string;
  piwikEventName: string;
  variant: 'primary' | 'secondary';
  position: 'left' | 'center' | 'right';
};

export const videoWithCaptionComponentName = 'shared.video-with-caption';

export type VideoWithCaptionData = {
  strapi_component: typeof videoWithCaptionComponentName;
} & {
  video: ResponsiveVideoData;
  caption?: string | null;
};

export const responsiveImageComponentName = 'shared.responsive-image';

export type ResponsiveImage = {
  strapi_component: typeof responsiveImageComponentName;
} & StrapiResponsiveImageData;

export type ClaimWithContentSection =
  | IntroTextData
  | TextBlockData
  | VideoWithCaptionData
  | ResponsiveImage
  | ButtonData;

export type SectionWithImageGroups =
  | IntroTextData
  | TextBlockData
  | VideoWithCaptionData
  | ResponsiveImage[]
  | ButtonData;
